import React from 'react';
import { Skeleton } from '@mui/material';
import CarBrandCharacteristics from '../../../CarBrandCharacteristics/CarBrandCharacteristics';
import { PublicationMobileCharacteristicsProps } from '../../interfaces';
import styles from '../../publicationDetailMobile.module.scss';



const PublicationMobileCharacteristics: React.FC<PublicationMobileCharacteristicsProps> = ({
    publication,
    loading,
    brand,
    selectedVersion,
    setOpenAdditionalModal
}) => {
    if (brand) {
        return (
            <>
                <CarBrandCharacteristics
                    publication={publication}
                    selectedVersion={selectedVersion}
                />
                <div 
                    className={styles.additionalCharacteristicsLink} 
                    onClick={() => setOpenAdditionalModal && setOpenAdditionalModal(true)}
                >
                    Ver características adicionales
                </div>
            </>
        );
    }

    const buildCharacteristics = () => {
        if (publication?.caracteristics) {
            const desiredCharacteristics = ['Carrocería', 'Transmisión', 'Combustible', 'Puertas'];
            return publication.caracteristics.filter((item: any) => 
                desiredCharacteristics.includes(item?.name)
            ) || [];
        }
        const vd = publication?.vehicle_data;
        if (!vd) return [];
        const chars = [];
        if (vd.type) chars.push({ name: 'Carrocería', value: vd.type });
        if (vd.transmission) chars.push({ name: 'Transmisión', value: vd.transmission });
        if (vd.fuel) chars.push({ name: 'Combustible', value: vd.fuel });
        if (vd.doors) chars.push({ name: 'Puertas', value: vd.doors });
        return chars;
    };
    const filteredCharacteristics = buildCharacteristics();

    return (
        <div className={styles.compactCharacteristics}>
            {filteredCharacteristics.map((item: any, index: number) => (
                <React.Fragment key={index}>
                    <div className={styles.compactCharItem}>
                        {loading ? (
                            <Skeleton animation="wave" variant="text" width={80} />
                        ) : (
                            <span className={styles.compactCharValue}>
                                {item?.name === 'Puertas' 
                                    ? `${item?.value ?? "-"} puertas` 
                                    : item?.value ?? "-"}
                            </span>
                        )}
                    </div>
                    {index < filteredCharacteristics.length - 1 && (
                        <div className={styles.compactCharSeparator}>|</div>
                    )}
                </React.Fragment>
            ))}
        </div>
    );
};

export default PublicationMobileCharacteristics;
